import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import getServices from "../../Services/get-service";
import Button from "../SelectValue/Button";
import swal from "sweetalert";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CreateCategory from "./createCategory";
import InvestmentCard from "./InvestmentCard";

export default function InvestmentCategory() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getServices
      .getAllInvestments() 
      .then((response) => {
        setLoading(false);
        if (response.data.status === "2000") {
          setCategories(response.data.data || []);
        } else {
          swal(response.data.description);
        }
      })
      .catch(() => setLoading(false));
  }, []);

  const handleCategoryClick = (category) => {
  navigate(`/investment/${category.id}`, { state: { name: category.name } });
};


  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">
          Investment Categories
        </h2>
        
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="p-4 bg-white border rounded-lg shadow-sm">
              <Skeleton height={30} width="80%" />
              <Skeleton count={3} />
            </div>
          ))}
        </div>
      ) : categories.length === 0 ? (
        <div className="text-center text-gray-500 mt-10">
          No investment categories found.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category, i) => (
            <InvestmentCard
              key={i}
              title={category.name}
              description={category.description}
              createdDate={category.createdDate}
              onClick={() => handleCategoryClick(category)}
            />
          ))}
        </div>
      )}

      {showModal && <CreateCategory onClose={() => setShowModal(false)} />}
    </div>
  );
}
